import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.min.css';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';

const processData = (data) => {
  const flattenedData = [];
  const flattenRowRecursive = (row, parentPath) => {
    row['invoiceAmount'] = row.invoiceAmount.toLocaleString();
    row['paid'] = row.paid.toLocaleString();
    row['balance'] = row.balance.toLocaleString();
    row["zeroToThirty"] = row.zeroToThirty !== null ? row.zeroToThirty.toLocaleString() : null;
    row["thirtyOneToSixty"] = row.thirtyOneToSixty !== null ? row.thirtyOneToSixty.toLocaleString() : null;
    row["sixtyOneToNinty"] = row.sixtyOneToNinty !== null ? row.sixtyOneToNinty.toLocaleString() : null;
    row["nintyOneToOneTwenty"] = row.nintyOneToOneTwenty !== null ? row.nintyOneToOneTwenty.toLocaleString() : null;
    row["oneTwentyOneToOneFifty"] = row.oneTwentyOneToOneFifty !== null ? row.oneTwentyOneToOneFifty.toLocaleString() : null;
    row["oneFiftyOneToOneEighty"] = row.oneFiftyOneToOneEighty !== null ? row.oneFiftyOneToOneEighty.toLocaleString() : null;
    row["oneEightyOneToTwoHundredTen"] = row.oneEightyOneToTwoHundredTen !== null ? row.oneEightyOneToTwoHundredTen.toLocaleString() : null;
    row["twoHundredElevenToTwoFourty"] = row.twoHundredElevenToTwoFourty !== null ? row.twoHundredElevenToTwoFourty.toLocaleString() : null;
    row["twoHundredFourtyOneToTwoHundredSeventy"] = row.twoHundredFourtyOneToTwoHundredSeventy !== null ? row.twoHundredFourtyOneToTwoHundredSeventy.toLocaleString() : null;
    row["twoHundredSenventyOneToThreeHundred"] = row.twoHundredSenventyOneToThreeHundred !== null ? row.twoHundredSenventyOneToThreeHundred.toLocaleString() : null;
    row["threeHundredOneToThreeThirty"] = row.threeHundredOneToThreeThirty !== null ? row.threeHundredOneToThreeThirty.toLocaleString() : null;
    row["threeHundredThirtyOneToThreeHundredSixty"] = row.threeHundredThirtyOneToThreeHundredSixty !== null ? row.threeHundredThirtyOneToThreeHundredSixty.toLocaleString() : null;
    row["moreThenOneYear"] = row.moreThenOneYear !== null ? row.moreThenOneYear.toLocaleString() : null;
    const dataPath = [...parentPath, row.orderCategory];
    flattenedData.push({ ...row, dataPath });
    if (row.subCategories) {
      row.subCategories.forEach((underling) =>
        flattenRowRecursive(underling, dataPath)
      );
    }
  };
  data.forEach((row) => flattenRowRecursive(row, []));
  return flattenedData;
};

const StatementGrid = (props) => {
  const [rowData, setRowData] = useState();
  const [monthRange, setMonthRange] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    { field: "piNumber", enableRowGroup: true, headerName: "Invoice", minWidth: 150,},
    { field: "invoiceAmount", enableRowGroup: true, headerName: "Invoice Amount", minWidth: 150,},
    { field: "paid", enableRowGroup: true, headerName: "Paid", minWidth: 150,},
    { field: "balance", enableRowGroup: true, headerName: "Balance", minWidth: 150,},
    { field: "balance", enableRowGroup: true, headerName: "Future Due", minWidth: 150,},
    { field: "balance", enableRowGroup: true, headerName: "Current Due", minWidth: 150,},
    { field: "zeroToThirty", enableRowGroup: true, headerName: "0-30", minWidth: 130,},
    { field: "thirtyOneToSixty", enableRowGroup: true, headerName: "31-60", minWidth: 130,},
    { field: "sixtyOneToNinty", enableRowGroup: true, headerName: "61-90", minWidth: 130,},
    { field: "nintyOneToOneTwenty", enableRowGroup: true, headerName: "91-120", minWidth: 130,},
    { field: "oneTwentyOneToOneFifty", enableRowGroup: true, headerName: "121-150", minWidth: 130,},
    { field: "oneFiftyOneToOneEighty", enableRowGroup: true, headerName: "151-180", minWidth: 130,},
    { field: "oneEightyOneToTwoHundredTen", enableRowGroup: true, headerName: "181-210", minWidth: 130,},
    { field: "twoHundredElevenToTwoFourty", enableRowGroup: true, headerName: "211-240", minWidth: 130,},
    { field: "twoHundredFourtyOneToTwoHundredSeventy", enableRowGroup: true, headerName: "241-270", minWidth: 130,},
    { field: "twoHundredSeventyOneToThreeHundred", enableRowGroup: true, headerName: "271-300", minWidth: 130,},
    { field: "threeHundredOneToThreeThirty", enableRowGroup: true, headerName: "301-330", minWidth: 130,},
    { field: "threeHundredThirtyOneToThreeSixty", enableRowGroup: true, headerName: "331-360", minWidth: 130,},
    { field: "moreThenOneYear", enableRowGroup: true, headerName: ">= 1 Yr", minWidth: 130,},
    { field: "paymentTerm", enableRowGroup: true, headerName: "Payment Term", minWidth: 130,},
  ]);

  const [columnDefsMonthWise, setColumnDefsMonthWise] = useState([
    // { field: "piNumber", enableRowGroup: true, headerName: "Invoice", },
    // { field: "invoiceAmount", enableRowGroup: true, headerName: "Invoice Amount", },
    // { field: "paid", enableRowGroup: true, headerName: "Paid", },
    // { field: "balance", enableRowGroup: true, headerName: "Balance", },
    // { field: "balance", enableRowGroup: true, headerName: "Future Due", },
    // { field: "balance", enableRowGroup: true, headerName: "Current Due", },
    // { field: "zeroToThirty", enableRowGroup: true, headerName: monthRange[0], },
    // { field: "thirtyOneToSixty", enableRowGroup: true, headerName: "February", },
    // { field: "sixtyOneToNinty", enableRowGroup: true, headerName: "March", },
    // { field: "nintyOneToOneTwenty", enableRowGroup: true, headerName: "April", },
    // { field: "oneTwentyOneToOneFifty", enableRowGroup: true, headerName: "May", },
    // { field: "oneFiftyOneToOneEighty", enableRowGroup: true, headerName: "June", },
    // { field: "oneEightyOneToTwoHundredTen", enableRowGroup: true, headerName: "July", },
    // { field: "twoHundredElevenToTwoFourty", enableRowGroup: true, headerName: "August", },
    // { field: "twoHundredFourtyOneToTwoHundredSeventy", enableRowGroup: true, headerName: "September", },
    // { field: "twoHundredSeventyOneToThreeHundred", enableRowGroup: true, headerName: "October", },
    // { field: "threeHundredOneToThreeThirty", enableRowGroup: true, headerName: "November", },
    // { field: "threeHundredThirtyOneToThreeSixty", enableRowGroup: true, headerName: "December", },
    // { field: "moreThenOneYear", enableRowGroup: true, headerName: "> 1 Yr", },
    // { field: "paymentTerm", enableRowGroup: true, headerName: "Payment Term", },

  ]);

  const stateRef = useRef();
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const gridStateId = useRef();
  const saveGridStateName = 'budgetSummaryList';
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      floatingFilter: true,
      sortable: true,
      resizable: true,
      filter: 'agMultiColumnFilter',
    };
  }, []);
  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: 'Order Type',
      field: 'orderCategory',
      cellRendererParams: {
        suppressCount: true,
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        treeList: true,
      },
      minWidth: 280,
    };
  }, []);
  const getDataPath = useMemo(() => {
    return (data) => data.dataPath;
  }, []);
  const getRowId = useMemo(() => {
    return (params) => params.data._id;
  }, []);

  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      props.gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      props.gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    setRowData(processData(props.rowData));
    autoSizeAll(false);
  }, []);

  const onFilterChanged = (params) => {
    stateData.filter = params?.api?.getFilterModel();
    setStateData(stateData)
  }

  const onColumnStateChanged = (params) => {
    stateData.columnState = params?.columnApi?.getColumnState();
    stateData.columnGroupState = params?.columnApi?.getColumnGroupState();
  }
  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  }

  const onFirstDataLoad = async (params) => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.gridState}`;
    const savedState = await OAuthService.getList(url + '/fetchState?screenName=' + saveGridStateName);
    const data = savedState?.data;

    if (data) {
      gridStateId.current = data?.id;
      data.screenState.filter && params.api.setFilterModel(data?.screenState.filter);
      data.screenState.columnState && params.columnApi.applyColumnState({ state: data?.screenState?.columnState, applyOrder: true });
      data.screenState.columnGroupState && params.columnApi.setColumnGroupState(data?.screenState?.columnGroupState);
    }
  }

  const getPrevious12Months = (dateStr) => {
    let currentDate = new Date(dateStr);
    return Array.from({ length: 13 }, () => {
      const monthYear = `${currentDate.toLocaleString('default', { month: 'long' })} ${currentDate.getFullYear()}`;
      currentDate.setMonth(currentDate.getMonth() - 1);
      return monthYear;
    }).reverse();
  };

  // Example Usage:
  const dynamicDate = '2023-08-15'; // This date is dynamic
  useEffect(() => {
    if (props.cutoffDate) {
      const monthsRange = getPrevious12Months(dynamicDate);
      const reverseData = monthsRange.reverse();

      setColumnDefsMonthWise([
        { field: "piNumber", enableRowGroup: true, headerName: "Invoice", minWidth: 150,},
        { field: "invoiceAmount", enableRowGroup: true, headerName: "Invoice Amount", minWidth: 150,},
        { field: "paid", enableRowGroup: true, headerName: "Paid", minWidth: 150,},
        { field: "balance", enableRowGroup: true, headerName: "Balance", minWidth: 150,},
        { field: "balance", enableRowGroup: true, headerName: "Future Due", minWidth: 150,},
        { field: "balance", enableRowGroup: true, headerName: "Current Due", minWidth: 150,},
        { field: "zeroToThirty", enableRowGroup: true, headerName: reverseData[0], minWidth: 130,},
        { field: "thirtyOneToSixty", enableRowGroup: true, headerName: reverseData[1], minWidth: 130,},
        { field: "sixtyOneToNinty", enableRowGroup: true, headerName: reverseData[2], minWidth: 130,},
        { field: "nintyOneToOneTwenty", enableRowGroup: true, headerName: reverseData[3], minWidth: 130,},
        { field: "oneTwentyOneToOneFifty", enableRowGroup: true, headerName: reverseData[4], minWidth: 130,},
        { field: "oneFiftyOneToOneEighty", enableRowGroup: true, headerName: reverseData[5], minWidth: 130,},
        { field: "oneEightyOneToTwoHundredTen", enableRowGroup: true, headerName: reverseData[6], minWidth: 130,},
        { field: "twoHundredElevenToTwoFourty", enableRowGroup: true, headerName: reverseData[7], minWidth: 130,},
        { field: "twoHundredFourtyOneToTwoHundredSeventy", enableRowGroup: true, headerName: reverseData[8], minWidth: 130,},
        { field: "twoHundredSeventyOneToThreeHundred", enableRowGroup: true, headerName: reverseData[9], minWidth: 130,},
        { field: "threeHundredOneToThreeThirty", enableRowGroup: true, headerName: reverseData[10], minWidth: 130,},
        { field: "threeHundredThirtyOneToThreeSixty", enableRowGroup: true, headerName: reverseData[11], minWidth: 130,},
        { field: "moreThenOneYear", enableRowGroup: true, headerName: `>= ${reverseData[12]}`, minWidth: 130,},
        { field: "paymentTerm", enableRowGroup: true, headerName: "Payment Term", minWidth: 130,},
      ]);
    }
  }, [props.cutoffDate])

  return (
    <>
      <div id="chartOfAccountGrid" className="ag-theme-alpine-dark" style={{ height: 550, width: '100%' }}>
        <AgGridReact
          ref={props.gridRef}
          rowData={rowData}
          columnDefs={props.viewOptions === 'View it monthly' ? columnDefsMonthWise : columnDefs}
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          treeData={true}
          animateRows={true}
          groupDefaultExpanded={-1}
          getDataPath={getDataPath}
          getRowId={getRowId}
          onGridReady={onGridReady}
          // onCellValueChanged={onCellValueChanged}
          onFirstDataRendered={onFirstDataLoad}
          onFilterChanged={onFilterChanged}
          onSortChanged={onColumnStateChanged}
          onColumnVisible={onColumnStateChanged}
          onColumnPinned={onColumnStateChanged}
          onColumnResized={onColumnStateChanged}
          onColumnMoved={onColumnStateChanged}
          onColumnRowGroupChanged={onColumnGroupChange}
        ></AgGridReact>
      </div>
    </>
  )
};

export default StatementGrid;